import { curveMonotoneX } from '@visx/curve';
import { AreaStack as VisxAreaStack, LinePath } from '@visx/shape';
import { ScaleLinear } from 'd3-scale';
import { Fragment } from 'react';

import { CategoryData } from '../grouped-chart/types';
import { generateStackedChartDataByKeys } from './utils';
import { increaseBrightness } from '../utils';
import { CategoryScale } from './types';

type LineStackProps = {
  data: CategoryData;
  keys: string[];
  valueScale: ScaleLinear<number, number>;
  categoryScale: CategoryScale;
  highlightKey?: string;
};

export const LineStack = (props: LineStackProps) => {
  const { data, keys, categoryScale, valueScale, highlightKey } = props;

  const stackedData = generateStackedChartDataByKeys(data, keys);

  return (
    <VisxAreaStack
      keys={keys}
      data={stackedData.items}
      order="reverse"
      x={(d) =>
        (categoryScale(d.data.categoryValue.formatted) ?? 0) + categoryScale.bandwidth() / 2
      }
      y0={(d) => valueScale(d[0])}
      y1={(d) => valueScale(d[1]) ?? valueScale.range()[0]}
      curve={curveMonotoneX}>
      {({ stacks }) =>
        stacks.map((stack) => {
          const color = data.series.find(({ key }) => key === stack.key)?.color ?? '';
          return (
            <Fragment key={`stack-${stack.key}`}>
              <LinePath
                data={stack.map((item) => ({
                  categoryValue: item.data.categoryValue,
                  value: item.at(1) ?? 0,
                }))}
                x={({ categoryValue }) =>
                  (categoryScale(categoryValue.formatted) ?? 0) + categoryScale.bandwidth() / 2
                }
                y={({ value }) => valueScale(value) ?? 0}
                stroke={increaseBrightness(color, 20)}
                strokeOpacity={highlightKey === stack.key || highlightKey === undefined ? 1 : 0.3}
                curve={curveMonotoneX}
              />
            </Fragment>
          );
        })
      }
    </VisxAreaStack>
  );
};
